import { animateBeforeAfterPanelStats } from './before-after-stats-animation.js';

/**
 * @param {HTMLElement} panel
 * @param {number} index
 */
function activateStatsPair(panel, index) {
	const statsPairs = panel?.querySelector('.js-before-after-stats-pairs');
	if (!statsPairs) {
		return;
	}

	const statsSlides = Array.from(statsPairs.querySelectorAll('.before-after__stats-pair-slide'));
	const indexStr = String(index);

	statsSlides.forEach((slide) => {
		const isActive = slide.dataset.pairIndex === indexStr;
		slide.classList.toggle('is-active', isActive);
		slide.hidden = !isActive;

		if (!isActive) {
			return;
		}

		delete slide.dataset.statsAnimated;
		animateBeforeAfterPanelStats(slide, { force: true });
	});
}

/**
 * @param {HTMLElement} panel
 */
function initPanelPairs(panel) {
	const chartPairs = panel.querySelector('.js-before-after-chart-pairs');
	const slides = chartPairs
		? Array.from(chartPairs.querySelectorAll('.before-after__chart-pair-slide'))
		: [];

	if (slides.length <= 1) {
		return;
	}

	const dots = Array.from(chartPairs.querySelectorAll('.before-after__chart-pairs-dot'));
	let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
	if (activeIndex === -1) {
		activeIndex = 0;
	}

	const activate = (index) => {
		activeIndex = ((index % slides.length) + slides.length) % slides.length;

		slides.forEach((slide, i) => {
			const isActive = i === activeIndex;
			slide.classList.toggle('is-active', isActive);
			slide.hidden = !isActive;
		});

		dots.forEach((dot, i) => {
			dot.classList.toggle('is-active', i === activeIndex);
		});

		activateStatsPair(panel, activeIndex);
	};

	// The stats arrows are the single control for the whole unit (image +
	// stats move together); the chevrons drawn on the image itself are
	// decorative only, matching the original design.
	panel.addEventListener('click', (event) => {
		if (!(event.target instanceof Element)) {
			return;
		}

		if (event.target.closest('.before-after__stats-btn--prev')) {
			activate(activeIndex - 1);
			return;
		}

		if (event.target.closest('.before-after__stats-btn--next')) {
			activate(activeIndex + 1);
			return;
		}

		const dot = event.target.closest('.before-after__chart-pairs-dot');
		if (dot) {
			const index = dots.indexOf(dot);
			if (index !== -1) {
				activate(index);
			}
		}
	});
}

export function initBeforeAfterChartPairs() {
	document.querySelectorAll('.before-after__category-panel').forEach((panel) => {
		initPanelPairs(panel);
	});
}
